// extracted by mini-css-extract-plugin
module.exports = {"collapseArrow":"style__collapseArrow__ZORcF","expanded":"style__expanded__YBRsd","collapsed":"style__collapsed__gto6f"};